// extracted by mini-css-extract-plugin
export var applicationInformationRow = "ApplicationInformationRow-module__applicationInformationRow___9mdPe";
export var row = "ApplicationInformationRow-module__row___Xer1P";